import React, { FC, useState } from "react";
import { Checkbox } from "@pd/pd-ui-kit";

import { IDealerToAssign } from "~/entity/Dealers/model/schema";
import {
  useAddDealerToUserMutation,
  useDeleteDealerFromUserMutation,
} from "~/schemas/generated/graphql";

interface IProps {
  dealer: IDealerToAssign;
  userId?: string | number;
  isDisabled?: boolean;
  onCompleted: () => void;
}

const DealerAssignCheckbox: FC<IProps> = ({
  dealer,
  userId,
  isDisabled = false,
  onCompleted,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleCompleted = () => {
    setIsLoading(false);
    onCompleted();
  };
  const handleError = () => {
    setIsLoading(false);
  };

  const [addDealerToUserMutation] = useAddDealerToUserMutation({
    onCompleted: handleCompleted,
    onError: handleError,
  });
  const [deleteDealerFromUserMutation] = useDeleteDealerFromUserMutation({
    onCompleted: handleCompleted,
    onError: handleError,
  });

  const onChange = () => {
    setIsLoading(true);
    const variables = {
      UserId: String(userId),
      DealerId: String(dealer.id),
    };
    if (dealer.isMy) {
      deleteDealerFromUserMutation({ variables });
    } else {
      addDealerToUserMutation({ variables });
    }
  };

  return (
    <Checkbox
      checked={dealer.isMy}
      disabled={isDisabled || isLoading}
      onChange={onChange}
    />
  );
};

export default DealerAssignCheckbox;
